import { CompleteNav } from 'ionic-ui';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { toggleSideBar } from '../../store/slices/sideBar/sideBarSlice';

const MainNavBar = React.memo(function () {
  const dispatch = useDispatch();
  const sideBarController = useCallback((value: boolean) => {
    dispatch(toggleSideBar(value));
  }, []);

  return (
    <CompleteNav
      displaySidebar={sideBarController}
      purpose="store-app"
      notificationsUrl={false}
      homeUrl={false}
      dashUrl="/dashboard/settings/store-profile"
      cartUrl={false}
      favoriteUrl={false}
    />
  );
});

export default MainNavBar;
MainNavBar.displayName = 'MainNavBar';
